import { Component, Prop, Vue } from 'vue-property-decorator'
import UserConfigurationPrintTabReportModel
    from '@/components/userConfiguration/print/tab-report-model/user-configuration-print-tab-report-model.vue'
import {
    ReportModelConfigurationMatch
} from '@/modules/printModule/services/report-model-configuration/report-model-configuration.model'
import { AvailablePrinter } from '@/modules/printModule/services/anapath-printer-rest-client/anapath-printer-rest-client.model'

@Component({
    components: {
        UserConfigurationPrintTabReportModel
    }
})
export default class UserConfigurationPrintTabModel extends Vue {
    @Prop() readonly reportModels!: ReportModelConfigurationMatch[]
    @Prop() readonly printers!: AvailablePrinter[]
}
